/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Warehouse_SubmitInputs */

const vi_qr_warehouse_submit = /** @type {(inputs: Qr_Warehouse_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở phiếu`)
};

/**

* @param {Qr_Warehouse_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_warehouse_submit = /** @type {((inputs?: Qr_Warehouse_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Warehouse_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_warehouse_submit(inputs)
});